import React, {Fragment, useEffect, useState} from "react";
import AdvancedSearch from "./index";
import {useAdvancedSearchSCMutation} from "../../core/api/solitaire-state-api";

export default function AdvancedSearchSC() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchSCMutation} />
}